module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rank-policy"
  }, [_vm._v("\n  " + _vm._s(_vm.$t('proficiency.standard_update', {
    month: _vm.proficiencyUpdateDate.month,
    day: _vm.proficiencyUpdateDate.day
  })) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61b4ef35","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/cat-main/components/CatRankPolicy.vue
// module id = 1582
// module chunks = 1